<template>
  <div class="openQuestionContainer">
    <b-row class="py-3">
      <b-col md="12" class="mb-3">
        <h3>Homework time </h3>
      </b-col>
      <!-- {{ this.data }} -->
      <b-col class="mb-3" md="12" v-for="(subTopic,index) in data.subTopics" :key="subTopic.id">
        <h4 class="mb-2">{{subTopic.open_questions}}</h4>
        <p>Enter your response below</p>
        <!-- <b-form-textarea
          id="textarea-rows"
          placeholder="Type here...."
          rows="8"
          class="rounded-lg"
          v-model="form[index].answer"
        ></b-form-textarea> -->
        <quill-editor v-model="form[index].answer" :options="getEditorOptions(index)">
          <div :id="'toolbar-' + index" slot="toolbar">
              <select class="ql-font">
                <option selected="selected" />
                <option value="serif" />
                <option value="monospace" />
              </select>
              <button class="ql-bold">Bold</button>
              <button class="ql-underline" value="super" />
              <button class="ql-italic">Italic</button>
              <button class="ql-list" value="ordered" />
              <button class="ql-list" value="bullet" />
              <select class="ql-size">
                <option value="small" />
                <option selected />
                <option value="large" />
                <option value="huge" />
              </select>
              <select class="ql-header"></select>
              <button class="ql-list" />
              <button class="ql-script" value="sub" />
              <button class="ql-script" value="super" />
              <!-- <button class="ql-link" value="super" /> -->
              <button class="ql-image" />
              <select class="ql-align"></select>
              <select class="ql-color"></select>
              <select class="ql-background"></select>
            </div>
          </quill-editor>
      </b-col>
    </b-row>
    <b-row class="submitContainer">
      <div class="w-100 d-flex justify-content-end p-2">
        <!-- v-if=" index+1 != data.subTopics[0].MCQ.length" -->
        <button
            @click="submit"
            :class="
                hasAnyAnswerFilled
                ? 'btn btn-primary rounded-pill px-4'
                : 'btn btn-secondary cursor-disabled rounded-pill px-4'
            "
            :disabled="loadSubmit"
        >
          <b-spinner v-if="loadSubmit" variant="light" style="width: 20px; height: 20px;" label="Spinning"></b-spinner>
          <div v-else>Submit</div> 
        </button>
      </div>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import serverURL from "@/constants";
import VueApexCharts from "vue-apexcharts";
import "quill/dist/quill.core.css";
import { quillEditor } from "vue-quill-editor";
import {
  BIcon,
  BCard,
  BRow,
  BCol,
  BCardText,
  BButton,
  BLink,
  BListGroup,
  BListGroupItem,
  BSpinner,
  BCardTitle,
  BCardBody,
  BTab,
  BTabs,
  BAlert,
  BFormTextarea
} from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
export default {
  components: {
    quillEditor,
    VueApexCharts,
    BCard,
    BRow,
    BCol,
    BCardText,
    BButton,
    BLink,
    BListGroup,
    BListGroupItem,
    BCardTitle,
    BSpinner,
    BCardBody,
    BTab,
    BTabs,
    BAlert,
    BIcon,
    FeatherIcon,
    BFormTextarea
  },
  props: {
    data: { default: null },
  },
  computed: {
    ...mapGetters({
      item: "topics/item",
      loadSubmit:"lessonPlans/loadSubmit"
    }),
    id() {
      return this.$route.params.id ? this.$route.params.id : null;
    },
    hasAnyAnswerFilled() {
      return this.form.some(item => item.answer && item.answer.trim() !== '');
    }
  },
  data() {
    return {
      selectedOption: null,
      form: this.data.subTopics.map(subTopic => ({
        answer: '',
        sub_topic_id: subTopic.id, 
        topic_id: this.$route.params.id
      }))
    };
  },
  methods: {
    getEditorOptions(index) {
      
      return {
        modules: {
          toolbar: `#toolbar-${index}`,
        },
        theme: "snow",
      };
    },
    checkQuestion(index){
        // this.currentQuestion = this.data.subTopics[0].MCQ[this.index]
    },
    select(option) {
      this.selectedOption = option;
    },
    selectedClass(option) {
      if (this.selectedOption && option.id == this.selectedOption.id)
        return "border border-white rounded-lg w-100 p-2 cursor-pointer selected";
      return "border border-white rounded-lg w-100 p-2 cursor-pointer";
    },
    submit(){
        try {
          this.$store.dispatch('lessonPlans/answerOpenQuestions', this.form).then((resp)=>{
            this.$router.push({name: 'finish_lesson', params:{
              result: 100,
              module_id: resp.module_id,
              current_id: this.$route.params.id,
              next_id: resp.next_id
            }})
          })
        } catch (error) {
            if (error.response) {
                this.$swal({
                    icon: 'error',
                    title: `<h4>${error.response.data.error}</h4>`,
                    showConfirmButton: true,
                    confirmButtonColor: '#E84185',
                    allowOutsideClick: true
                });
            }
        }
    }
  },
  mounted(){
    this.checkQuestion()
  }
};
</script>

<style scoped lang="scss">
  @import "@core/scss/vue/libs/quill.scss";
  @import "@core/scss/vue/libs/vue-flatpicker.scss";
.selected {
  border: 1px solid #e84185 !important;
}
.openQuestionContainer{
  position: relative;
}
.submitContainer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 10vh;
  background: #0b0b0b;
}
</style>